import { render, staticRenderFns } from "./chateau-montrose.vue?vue&type=template&id=13a1c31d&scoped=true"
import script from "./chateau-montrose.vue?vue&type=script&lang=js"
export * from "./chateau-montrose.vue?vue&type=script&lang=js"
import style0 from "./chateau-montrose.vue?vue&type=style&index=0&id=13a1c31d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1c31d",
  null
  
)

export default component.exports